import { reactive } from 'vue';
import auth from '@/auth.js';

const state = reactive({});

function resolveUrl(url) {
	if (url && url.startsWith('/uploads/')) {
		return process.env.BASE_URL + url.slice(1);
	}
	return url;
}

function unresolveUrl(url) {
	const prefix = process.env.BASE_URL + 'uploads/';
	if (url && url.startsWith(prefix)) {
		return '/' + url.slice(process.env.BASE_URL.length);
	}
	return url;
}

function resolveItem(item) {
	return { ...item, img: resolveUrl(item.img), downloadLink: resolveUrl(item.downloadLink) };
}

async function fetchItems() {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/items`);
		if (!res.ok) return;
		const data = await res.json();
		Object.keys(data).forEach((category) => {
			state[category] = data[category].map(resolveItem);
		});
	} catch {
		// backend not reachable - keep local state empty
	}
}

function getItems(category) {
	return state[category] || [];
}

async function addItem(category, payload) {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/items`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', ...auth.authHeaders() },
			body: JSON.stringify({ category, ...payload }),
		});
		const data = await res.json().catch(() => ({}));
		if (!res.ok) {
			return { ok: false, error: data.error || 'Request failed' };
		}
		const item = resolveItem(data);
		if (!state[category]) state[category] = [];
		state[category].push(item);
		return { ok: true, item };
	} catch {
		return { ok: false, error: 'Network error' };
	}
}

async function updateItem(category, id, payload) {
	try {
		const body = {
			...payload,
			img: unresolveUrl(payload.img),
			downloadLink: unresolveUrl(payload.downloadLink),
		};
		const res = await fetch(`${process.env.BASE_URL}api/items/${category}/${id}`, {
			method: 'PUT',
			headers: { 'Content-Type': 'application/json', ...auth.authHeaders() },
			body: JSON.stringify(body),
		});
		const data = await res.json().catch(() => ({}));
		if (!res.ok) {
			return { ok: false, error: data.error || 'Request failed' };
		}
		const item = resolveItem(data);
		const list = state[category] || [];
		const index = list.findIndex((it) => it.id === id);
		if (index !== -1) list[index] = item;
		return { ok: true, item };
	} catch {
		return { ok: false, error: 'Network error' };
	}
}

async function deleteItem(category, id) {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/items/${category}/${id}`, {
			method: 'DELETE',
			headers: auth.authHeaders(),
		});
		if (!res.ok) {
			const data = await res.json().catch(() => ({}));
			return { ok: false, error: data.error || 'Request failed' };
		}
		state[category] = (state[category] || []).filter((it) => it.id !== id);
		return { ok: true };
	} catch {
		return { ok: false, error: 'Network error' };
	}
}

fetchItems();

export default { state, getItems, addItem, updateItem, deleteItem };
